
export type GetMainRepresentationByArticleIdLayerLoadMode = typeof GetMainRepresentationByArticleIdLayerLoadMode[keyof typeof GetMainRepresentationByArticleIdLayerLoadMode];


export const GetMainRepresentationByArticleIdLayerLoadMode = {
  None: 'None',
  GraphicLayers: 'GraphicLayers',
  LogicLayers: 'LogicLayers',
  All: 'All',
} as const;
